module.exports = __webpack_public_path__ + "static/media/base.5dd9820c.png";